import { SuiteService } from './src/services/suite.services';
export const suiteService = new SuiteService();
export default suiteService;
